<template>
  <div>
    <el-container>
      <el-header height="15%">
        <el-alert
          v-if="status === 200"
          title="Склад успешно удален."
          type="success"
          effect="dark"
        >
        </el-alert>
        <el-alert
          v-if="status === 422"
          title="Склад содержит товары."
          type="error"
          effect="dark"
        >
        </el-alert>
        <div class="row m-4">
          <div class="col-md-2">
            <h4>Склады</h4>
          </div>
        </div>
      </el-header>
      <el-main>
        <el-table :data="storages" empty-text="Нет данных" style="width: 100%">
          <el-table-column prop="id" label="Id" width="50"> </el-table-column>
          <el-table-column prop="title" label="Название" width="300">
          </el-table-column>
          <el-table-column prop="work_time" label="Время работы" width="180">
          </el-table-column>
          <el-table-column prop="phone" label="Телефон" width="300">
          </el-table-column>

          <el-table-column prop="sort" label="Сортировка"> </el-table-column>

          <el-table-column label="Активность" width="160">
            <template slot-scope="scope">
              <p v-if="!storages[scope.$index].activity">Нет</p>
              <p v-if="storages[scope.$index].activity">Да</p>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Действия" width="200">
            <template slot-scope="scope">
              <div class="storage__nav">
                <el-button
                  size="mini"
                  @click="(e) => a(e, storages[scope.$index].id)"
                >
                  Изменить
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="current"
          @current-change="getPage(current)"
          :hide-on-single-page="true"
          :page-size="paginator ? paginator.meta.per_page : 0"
          :page-count="paginator ? paginator.meta.last_page : 0"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { SETPRELOADER_STATE } from "@/store/mutation-types";

export default {
  name: "Advantages",
  data: function () {
    return {
      status: 0,
      storages: [],
      current: 0,
      total: 0,
      paginator: null,
    };
  },
  mounted() {
    this.getStorages();
  },
  methods: {
    getStorages: function () {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .get("/storage")
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.storages = response.data;
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    getPage: function (pageNum) {
      var qs = require("qs");
      if (pageNum !== null) {
        axios
          .get(
            "/api/admin/storage/storages?page=" +
              pageNum +
              "&" +
              qs.stringify(this.query)
          )
          .then((response) => {
            this.paginator = response.data;
            this.storages = response.data.data;
          })
          .catch((errors) => {
            if (errors.response.status === 401) {
              this.$router.push("/login");
            }
          });
      }

      this.success = "";
      return this.paginator.first_page_url;
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    a: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e);
      btn.style.pointerEvents = "none";

      axios
        .get("/storage/" + id)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          this.$store.dispatch("addStorage", response.data);
          this.$router.push("/storage/" + id + "/update");
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          this.errors = errors.response.data.errors;

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
  },
};
</script>

<style scoped>
.storage__nav {
  display: flex;
  max-width: 330px;
  justify-content: space-around;
}

p {
  margin-bottom: 0;
}
</style>

